import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Link,
  Breadcrumbs,
  InputAdornment,
  TextField,
  Stack,
  Button,
  Grid,
  AppBar,
} from "@mui/material";

import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { schedulegdata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import {
  SETTINGS_API_04,
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  Schedule_API_1,
} from "../../api/ApiModel";
import SearchAppBar from "../../components/common/search";
import CircularProgress from "@mui/material/CircularProgress";

function ViewSchedule() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchDetailsByDate();
  }, []);

  const fetchDetailsByDate = async (date) => {
    try {
      // Fetch data using the external API
      const result = await externalgetApi(Schedule_API_1, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        SCHEDULEDATE: "2023-1-1", // selected date or empty
        STS: CON_STATUS_ACTIVE,
      });

      if (result?.Table1?.length > 0) {
        // Update the main data state
        setData(result.Table1);
        // Initially, filtered data matches the full data
        setFilteredData(result.Table1);
      } else {
        setData([]);
        setFilteredData([]);
      }
    } catch (err) {
      console.error("Error fetching details:", err);
    } finally {
      setIsLoading(false); // Stop loading spinner after API call
    }
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchText(searchValue);

    // Filter rows based on searchText
    const filtered = data.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchValue)
      )
    );
    setFilteredData(filtered);
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                {/* <Link underline="hover">Settings</Link> */}
                <Link underline="none">View Schedule</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => navigate("/Schedules")}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box id="back-to-top-anchor">
        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="60vh"
          >
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <ViewData
            columns={schedulegdata.columns}
            rows={filteredData.map((item) => ({
              ...item,
              id: item.ORDERSTSCODE,
            }))}
            tabletitle={schedulegdata.name}
            gridid="ORDERSTSCODE"
            displayActions={false}
            // Only pass menuItems if it's not falsy
          />
        )}
      </Box>
    </div>
  );
}

export default ViewSchedule;
